import { ClientError } from "graphql-request";

export const getGraphqlErrors = (error: unknown) => {
  if (error && "response" in (error as ClientError)) {
    return (error as ClientError).response.errors;
  }
};
export const getGraphqlErrorMessages = (error: unknown) => getGraphqlErrors(error)?.map((error) => error.message);

export const getGraphqlError = (error: unknown) => getGraphqlErrors(error)?.[0];
export const getGraphqlErrorMessage = (error: unknown) => getGraphqlError(error)?.message;
